import React, { memo } from 'react';

import { SettingsPageAccount } from 'pages/Settings/SettingsPage/SettingsAccount';
import { SettingsPageInvoices } from 'pages/Settings/SettingsPage/SettingsInvoices';
import { SettingsPageOrganization } from 'pages/Settings/SettingsPage/SettingsOrganization';
import { SettingsPagePayment } from 'pages/Settings/SettingsPage/SettingsPayment';
import { SettingsPageTeam } from 'pages/Settings/SettingsPage/SettingsTeam';
import { capitalize } from 'utils';
import { AccountInformationProps } from 'pages/Settings/SettingsPage/Settings.types';

const pages = {
    SettingsPageAccount,
    SettingsPageInvoices,
    SettingsPageOrganization,
    SettingsPagePayment,
    SettingsPageTeam,
};

type PageComponentKey = keyof typeof pages;

function isValidPageKey(key: string): key is PageComponentKey {
    return key in pages;
}
export const SettingsPage = memo(function SettingsPage({
    pageKey,
    orderId,
    route,
    user,
    totems,
}: AccountInformationProps) {
    const componentKey = `SettingsPage${capitalize(pageKey)}`;
    const Component = isValidPageKey(componentKey) ? pages[componentKey] : null;
    return Component ? (
        <Component pageKey={pageKey} route={route} orderId={orderId} user={user!} totems={totems} />
    ) : null;
});
